import {ICostumer} from "@/types/costumer";
import { markers } from "@/utility";

export interface IInterventionFrequency {
    id?: number,
    description: string,
    year_interventions_amount: number,
    recent_inspection_interval: number,
    regular_situation_interval: number,
    expiring_situation_interval: number,
}

export function expirationStateDisplay(expirationStateCode: string) {
    switch (expirationStateCode) {
        case 'recent_inspection':
            return 'Ispezione recente'
        case 'regular_situation':
            return 'Situazione regolare'
        case 'expiring_situation':
            return 'In scadenza'
        case 'expired_situation':
            return 'Scaduto'
        default:
            return ''
    }
}

export function getMarkerColor(expirationStateCode: string) {
    switch (expirationStateCode) {
        case 'recent_inspection':
            return {r: 255, g: 255, b: 255, a: 255};
        case 'regular_situation':
            return {r: 255, g: 255, b: 255, a: 255};
        case 'expiring_situation':
            return {r: 255, g: 255, b: 255, a: 255};
        case 'expired_situation':
            return {r: 255, g: 255, b: 255, a: 255};
        default:
            return null
    }
}


export function getMarkerIconUrl(expirationStateCode: string) {
    switch (expirationStateCode) {
        case 'recent_inspection':
            return markers.cyan
        case 'regular_situation':
            return markers.green
        case 'expiring_situation':
            return markers.yellow
        case 'expired_situation':
            return markers.red
        default:
            return markers.white
    }
}
